import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { UlContainer, FloatingIcon } from './NotificationStyles';
import { formatDate } from 'utilities/util'
import { respEntries } from 'reducers/api/model';

interface INotitifcation {
    isVisible: boolean,
    displayAllBtn: boolean,
    data: respEntries[]
}
interface IProps extends INotitifcation, RouteComponentProps { }
export class _NotificationList extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }
    public navigateTo = (id:any = undefined) => {
        const URL = '/exception-management/notifications/open-notifications'
        const goTo = id? `${URL}?documentNumber=${id}`: URL;
        this.props.history.push(goTo)
    }
    public render() {
        // ItemType
        return (
            <React.Fragment>
                {this.props.isVisible && <UlContainer>
                    {this.props.data.map((data:any)=> (
                         <li onClick={() => this.navigateTo(data.documentNumber)} className="link" key={data.notificationId}>
                         <span>{data.documentNumber} | {data.docFinOpsStatus}</span>
                         <p>{data.finNumber && `${data.finNumber},`} {formatDate(data.createdDate)}</p>
                         <FloatingIcon className="fa fa-chevron-right" aria-hidden="true" />
                     </li>
                    ))}
                    {this.props.displayAllBtn && <li className="last-child"><button type="button" className="button button-transparent" onClick={() => this.navigateTo()}>view all</button></li>}
                </UlContainer>}
            </React.Fragment>
        );
    }
}

export const NotificationList = withRouter(_NotificationList);